<template>
  <div class="my-ads-container">
    <div
      v-if="isMobile"
      class="back-menu mobile-position-fixed"
    >
      <mobile-back-menu :title="$t('account-settings.my-ads.title')" />
    </div>
    <el-tabs
      v-if="user.id"
      v-model="activeName"
      class="my-ads-wrapper"
      @tab-click="handleClick"
    >
      <el-tab-pane
        :label="'('+ activeBadge +') ' + $t('account-settings.my-ads.active.text') "
        name="first"
      >
        <entity-list
          ref="entityListActive"
          res="ads"
          :filter="activeFilters || []"
          :sort="sort || []"
          :res-options="resourceOptions"
          :post-on-index="false"
          @response="activeBadge = $event.total"
        >
          <template
            slot="item"
            slot-scope="slotProps"
          >
            <ads-row
              :param-item="slotProps.item"
              :is-my-ads="true"
              @changed="reloadLists"
            />
          </template>
        </entity-list>
      </el-tab-pane>
      <el-tab-pane
        :label="'('+ inactiveBadge + ') ' + $t('account-settings.my-ads.inactive.text')"
        name="second"
      >
        <entity-list
          ref="entityListInactive"
          res="ads"
          :filter="inactiveFilters || []"
          :sort="sort || []"
          :res-options="resourceOptions"
          :post-on-index="false"
          @response="inactiveBadge = $event.total"
        >
          <template
            slot="item"
            slot-scope="slotProps"
          >
            <ads-row
              :param-item="slotProps.item"
              :is-my-ads="true"
              @changed="reloadLists"
            />
          </template>
        </entity-list>
      </el-tab-pane>
    </el-tabs>
    <el-col v-if="isMobile">
      <footer-menu />
    </el-col>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import EntityList from '@/components/Core/EntityList';
  import AdsRow from '@/components/Ads/AdsRow';
  import MobileBackMenu from '@/components/Mobile/MobileBackMenu';
  import FooterMenu from '@/components/Mobile/FooterMenu';

  export default {
    components: {
      FooterMenu,
      MobileBackMenu,
      AdsRow,
      EntityList,
    },
    data() {
      return {
        activeName: 'first',
        sort: [['publish_date', 'desc']],
        activeBadge: 0,
        inactiveBadge: 0,
        resourceOptions: {
          favoring_users: true,
          file: true,
          currency: true,
          favoring_logged_in_user: true,
          contact_info: true,
          'category:parent': true,
        },
      };
    },
    computed: {
      ...mapState({
        isMobile: state => state.isMobile,
        user: state => state.auth.user,
      }),
      ads_list() {
        return this.$store.state.ads.records;
      },
      activeFilters() {
        return [{
          property: 'active',
          operator: '=',
          value: 1,
        }, {
          property: 'user_id',
          operator: '=',
          value: this.user.id,
        }];
      },
      inactiveFilters() {
        return [{
          property: 'active',
          operator: '=',
          value: 0,
        }, {
          property: 'user_id',
          operator: '=',
          value: this.user.id,
        }];
      },
    },
    methods: {
      handleClick(/* tab, event */) {
        // eslint-disable-next-line no-console
        // console.log(tab, event);
      },
      reloadLists() {
        const lists = ['entityListActive', 'entityListInactive'];

        lists.forEach((listName) => {
          if (this.$refs[listName]) {
            this.$refs[listName].doRefresh();
          }
        });
      },
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/AccountSettings/MyAds.vue